export default __webpack_public_path__ + "729feaf7f58dc43954aafae9ee0797bd.png";